import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import moment from 'moment'
import {errorStatus} from '../../core/redux/status'
import {connectForm, arrayItemField, buttonField} from '../../core/redux/form'
import extract from '../../core/extract'
import {linkFinder} from '../../core/links'
import CheckboxToggle from '../../core/components/CheckboxToggle'
import DayPicker from '../../core/components/DayPicker'
import TimePicker from '../../core/components/TimePicker'
import DayRangePicker from '../../core/components/DayRangePicker'
import Icon from '../../core/components/Icon'
import {DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED, sendDefineUpdateInterventionPeriodForActivityCmd, updateDefineUpdateInterventionPeriodForActivityCmd, loadProvider, loadContact} from '../actions'
import {sendDefineInterventionZoneForInterventionPeriodCmd, sendDefineServiceChargeForInterventionPeriodCmd, sendDefineCallOutChargesForInterventionPeriodCmd, sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd, sendDefineRepairTimelimitForInterventionPeriodCmd, sendDefineInterventionTimelimitForInterventionPeriodCmd, sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd} from '../actions'
import {PERIOD_TYPES, TIME_SLOT_TYPES, WEEK_DAYS, DefineUpdateInterventionPeriodForActivityCmd} from '../models'
import i18n from '../i18n'
import style from './DefineUpdateInterventionPeriodForActivityForm.less'

function isContact(committed) {
    return !!committed.commitments
}

function periodMapper(period) {
    return {
        start: moment(period.start, 'HH:mm:ss').toDate(),
        end: moment(period.end, 'HH:mm:ss').toDate()
    }
}

function copyServiceChargeCmd(interventionPeriod) {
    return {
        charge: interventionPeriod.serviceCharge
    }
}

function copyInterventionZoneCmd(interventionPeriod) {
    return {
        zone: interventionPeriod.interventionZone
    }
}

function copyCallOutChargesCmd(interventionPeriod) {
    return {
        callOutCharges: interventionPeriod.callOutCharges
    }
}

function copySubscriptionsCmd(interventionPeriod) {
    return {
        subscriptions: interventionPeriod.subscriptions
    }
}

function copyRepairTimelimitCmd(interventionPeriod) {
    return {
        timelimits: interventionPeriod.repairTimelimits
    }
}

function copyInterventionTimelimitCmd(interventionPeriod) {
    return {
        timelimits: interventionPeriod.interventionTimelimits
    }
}

function copyExcludeOpeningTicketPurposesCmd(interventionPeriod) {
    return {
        openingTicketPurposes: interventionPeriod.excludedOpeningTicketPurposes
    }
}

function defineCmdUpdate(interventionPeriod, committed) {
    if (interventionPeriod) {
        return {
            interventionPeriodUid: interventionPeriod.uid,
            period: {
                ...interventionPeriod.period,
                periodRanges: interventionPeriod.period.periodRanges && interventionPeriod.period.periodRanges.map((periodRange) => ({
                    ...periodRange,
                    timeSlot: {
                        ...periodRange.timeSlot,
                        periods: periodRange.timeSlot.periods && periodRange.timeSlot.periods.map(periodMapper) || null
                    }
                })) || null,
                exclusions: interventionPeriod.period.exclusions && interventionPeriod.period.exclusions.map((exclusion) => ({
                    ...exclusion,
                    days: exclusion.days.map((d) => moment(d).toDate()),
                    timeSlot: {
                        ...exclusion.timeSlot,
                        periods: exclusion.timeSlot.periods && exclusion.timeSlot.periods.map(periodMapper) || null
                    }
                })) || null,
                days: interventionPeriod.period.days && interventionPeriod.period.days.map((d) => moment(d).toDate()) || null,
                timeSlot: interventionPeriod.period.timeSlot && {
                    ...interventionPeriod.period.timeSlot,
                    periods: interventionPeriod.period.timeSlot.periods && interventionPeriod.period.timeSlot.periods.map(periodMapper) || null
                },
                startDate: interventionPeriod.period.startDate && new Date(interventionPeriod.period.startDate),
                endDate: interventionPeriod.period.endDate && new Date(interventionPeriod.period.endDate)
            },
            commandType: committed._links.find(linkFinder(['UpdateInterventionPeriodForActivity', 'UpdateInterventionPeriod'])).rel
        }
    }

    return {
        interventionPeriodUid: null,
        period: {periodType: PERIOD_TYPES[0]},
        commandType: committed._links.find(linkFinder(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])).rel
    }
}

function weekDaysFilter(weekDays) {
    return (weekDay) => {
        return weekDays.indexOf(weekDay) >= 0
    }
}

class DefineUpdateInterventionPeriodForActivityForm extends Component {
    static propTypes = {
        committed: PropTypes.object.isRequired,
        activity: PropTypes.object.isRequired,
        interventionPeriod: PropTypes.object,
        interventionPeriods: PropTypes.array,
        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            openedSections: []
        }
    }

    componentWillMount() {
        const {dispatch, committed, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod, committed)
        dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.committed != this.props.committed
            || nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, committed, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod, committed)
            dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(update))
        }
    }

    _sendCmd(event) {
        const {dispatch, committed, activity, interventionPeriod, onSubmit} = this.props
        const {activeInterventionPeriod} = this.state

        var interventionPeriodUid = interventionPeriod && interventionPeriod.uid
        return dispatch(sendDefineUpdateInterventionPeriodForActivityCmd(committed._links, activity.uid)).then((action) => {
            interventionPeriodUid = interventionPeriodUid || action.events.find((e) => e.eventType == 'InterventionPeriodDefinedForActivity' || e.eventType == 'InterventionPeriodDefined').period.uid
            // copy selected intervention period
            // we have to execute all cmds sequencialy to avoid backend issues
            return activeInterventionPeriod && activeInterventionPeriod.interventionZone && dispatch(sendDefineInterventionZoneForInterventionPeriodCmd(committed._links, activity.uid, interventionPeriodUid, copyInterventionZoneCmd(activeInterventionPeriod)))
        }).then(() => {
            return activeInterventionPeriod && activeInterventionPeriod.serviceCharge && dispatch(sendDefineServiceChargeForInterventionPeriodCmd(activity.uid, interventionPeriodUid, copyServiceChargeCmd(activeInterventionPeriod)))
        }).then(() => {
            return activeInterventionPeriod && activeInterventionPeriod.callOutCharges && activeInterventionPeriod.callOutCharges.length > 0 && dispatch(sendDefineCallOutChargesForInterventionPeriodCmd(activity.uid, interventionPeriodUid, copyCallOutChargesCmd(activeInterventionPeriod)))
        }).then(() => {
            return activeInterventionPeriod && activeInterventionPeriod.subscriptions && activeInterventionPeriod.subscriptions.length > 0 && dispatch(sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(activity.uid, interventionPeriodUid, copySubscriptionsCmd(activeInterventionPeriod)))
        }).then(() => {
            return activeInterventionPeriod && activeInterventionPeriod.repairTimelimits && activeInterventionPeriod.repairTimelimits.length > 0 && dispatch(sendDefineRepairTimelimitForInterventionPeriodCmd(interventionPeriodUid, copyRepairTimelimitCmd(activeInterventionPeriod)))
        }).then(() => {
            return activeInterventionPeriod && activeInterventionPeriod.interventionTimelimits && activeInterventionPeriod.interventionTimelimits.length > 0 && dispatch(sendDefineInterventionTimelimitForInterventionPeriodCmd(interventionPeriodUid, copyInterventionTimelimitCmd(activeInterventionPeriod)))
        }).then(() => {
            return activeInterventionPeriod && activeInterventionPeriod.excludedOpeningTicketPurposes && activeInterventionPeriod.excludedOpeningTicketPurposes.length > 0 && dispatch(sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd(interventionPeriodUid, copyExcludeOpeningTicketPurposesCmd(activeInterventionPeriod)))
        }).then(() => {
            return isContact(committed) && dispatch(loadContact()) || dispatch(loadProvider())
        }).then(() => {
            onSubmit(event, 'InterventionPeriodDefinedForActivity', interventionPeriodUid)
        })
    }

    _toggleSection(event, name) {
        const {openedSections} = this.state

        event.preventDefault()

        const index = openedSections.indexOf(name)
        const nextOpenedSections = [...openedSections]

        if (index >= 0) {
            nextOpenedSections.splice(index, 1)
        } else {
            nextOpenedSections.push(name)
        }

        this.setState({openedSections: nextOpenedSections})
    }

    render() {
        const {dispatch, form, alternateForm, cmd, committed, activity, interventionPeriod, interventionPeriods, onSubmit, ...others} = this.props
        const {openedSections, activeInterventionPeriod} = this.state

        const formatTimeSlot = (timeSlot) => {
            if (timeSlot.periods) {
                return timeSlot.periods.map((period) => {
                    return moment(period.start).format(i18n.timeFormat.from) + ' ' + moment(period.end).format(i18n.timeFormat.to)
                }).join(', ')
            }
            return i18n.timeSlotTypeEnum.allDayLong
        }

        const periodField = (field) => {
            const value = {
                from: field.value && field.value.startDate,
                to: field.value && field.value.endDate
            }

            function onChange(value) {
                const nextValue = {
                    ...field.value,
                    startDate: value && value.from,
                    endDate: value && value.to
                }
                field.onChange(nextValue)
            }

            return {...field, value, onChange}
        }

        const activeInterventionPeriodField = () => {
            const value = activeInterventionPeriod && activeInterventionPeriod.period.uid || ''

            const onChange = (event) => {
                const activeInterventionPeriodId = event.target.value || null
                const activeInterventionPeriod = activeInterventionPeriodId && interventionPeriods.find((ip) => ip.period.uid == activeInterventionPeriodId)
                this.setState({activeInterventionPeriod})
            }

            return {value, onChange}
        }

        const renderTimeSlotForm = (form, cmd) => (
            <div>
                <Input
                    type='select'
                    name='timeSlotType'
                    {...form.timeSlotType()}>
                    {TIME_SLOT_TYPES.map((type, index) => (
                        <option
                            key={index}
                            value={type}>
                            {extract(i18n.timeSlotTypeEnum, type)}
                        </option>
                    ))}
                </Input>
                {form.periods && (
                    <div>
                        <ul className={style.group}>
                            {cmd && cmd.periods && cmd.periods.slice(1).reverse().map((period, index) => (
                                <li key={index}>
                                    <a
                                        href=''
                                        className={style.remove}
                                        onClick={(e) => form.periods.remove(e, period)}>
                                        <Icon icon='minus' size='xs' />
                                    </a>
                                    <p>
                                        <span>{moment(period.start).format(i18n.timeFormat.from)}</span>
                                        <span> {moment(period.end).format(i18n.timeFormat.to)}</span>
                                    </p>
                                </li>
                            ))}
                        </ul>
                        <Row>
                            <Col sm={6}>
                                <TimePicker
                                    {...form.periods.start()} />
                            </Col>
                            <Col sm={6}>
                                <TimePicker
                                    {...form.periods.end()} />
                            </Col>
                        </Row>
                        <ButtonToolbar>
                            {form.periods.isValid() && (
                                <Button
                                    bsStyle='link'
                                    onClick={() => form.periods.add()}>
                                    <Icon icon='plus' size='xs' />
                                    <span>{i18n.addTimeSlot}</span>
                                </Button>
                            )}
                            {cmd && cmd.periods && cmd.periods.length > 1 && (
                                <Button
                                    bsStyle='link'
                                    onClick={() => form.periods.remove()}>
                                    <Icon icon='minus' size='xs' />
                                    <span>{i18n.removeTimeSlot}</span>
                                </Button>
                            )}
                        </ButtonToolbar>
                    </div>
                )}
            </div>
        )

        return (
            <div className={style.default}>
                <Input
                    type='select'
                    name='periodType'
                    {...form.period.periodType()}>
                    {PERIOD_TYPES.map((type, index) => (
                        <option
                            key={index}
                            value={type}>
                            {extract(i18n.periodTypeEnum, type)}
                        </option>
                    ))}
                </Input>
                <Input
                    type='text'
                    name='label'
                    placeholder={i18n.label + ' *'}
                    {...form.period.label()} />
                {form.period.periodRanges && (
                    <div className={style.section}>
                        <h5>{i18n.periodRanges} <i>*</i></h5>
                        <ul className={style.group}>
                            {cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges.slice(1).reverse().map((periodRange, index) => (
                                <li key={index}>
                                    <a
                                        href=''
                                        className={style.remove}
                                        onClick={(e) => form.period.periodRanges.remove(e, periodRange)}>
                                        <Icon icon='minus' size='xs' />
                                    </a>
                                    <p>
                                        <span>{WEEK_DAYS.filter(weekDaysFilter(periodRange.weekDays)).map((wd) => moment.weekdays(WEEK_DAYS.indexOf(wd))).join(', ')}</span>
                                        <span> {formatTimeSlot(periodRange.timeSlot)}</span>
                                    </p>
                                </li>
                            ))}
                        </ul>
                        <CheckboxToggle
                            {...form.period.periodRanges.weekDays()}>
                            <Row>
                                <Col sm={6}>
                                    {WEEK_DAYS.slice(0, WEEK_DAYS.length / 2 + 1).map((weekDay, index) => (
                                        <Input
                                            key={index}
                                            type='checkbox'
                                            label={moment.weekdays(WEEK_DAYS.indexOf(weekDay))}
                                            value={weekDay} />
                                    ))}
                                </Col>
                                <Col sm={6}>
                                    {WEEK_DAYS.slice(WEEK_DAYS.length / 2 + 1, WEEK_DAYS.length).map((weekDay, index) => (
                                        <Input
                                            key={index}
                                            type='checkbox'
                                            label={moment.weekdays(WEEK_DAYS.indexOf(weekDay))}
                                            value={weekDay} />
                                    ))}
                                </Col>
                            </Row>
                        </CheckboxToggle>
                        {renderTimeSlotForm(alternateForm.period.periodRanges.timeSlot, cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges[0] && cmd.period.periodRanges[0].timeSlot)}
                        <ButtonToolbar>
                            {form.period.periodRanges.isValid() && (
                                <Button
                                    bsStyle='primary'
                                    bsSize='large'
                                    onClick={() => form.period.periodRanges.add(null, {timeSlot: {timeSlotType: TIME_SLOT_TYPES[0]}})}>
                                    {i18n.addPeriodRange}
                                </Button>
                            )}
                            {cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges.length > 1 && (
                                <Button
                                    bsStyle='danger'
                                    bsSize='large'
                                    onClick={() => form.period.periodRanges.remove()}>
                                    {i18n.removePeriodRange}
                                </Button>
                            )}
                        </ButtonToolbar>
                    </div>
                )}
                {form.period.exclusions && (
                    <div className={style.section}>
                        <h5>
                            <a
                                href=''
                                onClick={(e) => this._toggleSection(e, 'Exclusions')}>
                                <span>{i18n.exclusions}</span>
                                <Icon icon={openedSections.indexOf('Exclusions') >= 0 && 'up' || 'down'} size='xs' />
                            </a>
                        </h5>
                        {openedSections.indexOf('Exclusions') >= 0 && (
                            <div>
                                <ul className={style.group}>
                                    {cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.slice(1).reverse().map((exclusion, index) => (
                                        <li key={index}>
                                            <a
                                                href=''
                                                className={style.remove}
                                                onClick={(e) => form.period.exclusions.remove(e, exclusion)}>
                                                <Icon icon='minus' size='xs' />
                                            </a>
                                            <p>
                                                <span>{exclusion.days.map((d) => moment(d).format(i18n.dateFormat.longer)).join(', ')}</span>
                                                <span> {formatTimeSlot(exclusion.timeSlot)}</span>
                                            </p>
                                        </li>
                                    ))}
                                </ul>
                                <ul className={style.group}>
                                    {cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].days && cmd.period.exclusions[0].days.slice(1).reverse().map((day, index) => (
                                        <li key={index}>
                                            <a
                                                href=''
                                                className={style.remove}
                                                onClick={(e) => form.period.exclusions.days.remove(e, day)}>
                                                <Icon icon='minus' size='xs' />
                                            </a>
                                            <p>{moment(day).format(i18n.dateFormat.longer)}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className={style.dayPicker}>
                                    <DayPicker
                                        {...arrayItemField(form.period.exclusions.days())} />
                                </div>
                                <ButtonToolbar>
                                    {form.period.exclusions.days.isValid() && (
                                        <Button
                                            bsStyle='link'
                                            onClick={() => form.period.exclusions.days.add()}>
                                            <Icon icon='plus' size='xs' />
                                            <span>{i18n.addDay}</span>
                                        </Button>
                                    )}
                                    {cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].days && cmd.period.exclusions[0].days.length > 1 && (
                                        <Button
                                            bsStyle='link'
                                            onClick={() => form.period.exclusions.days.remove()}>
                                            <Icon icon='minus' size='xs' />
                                            <span>{i18n.removeDay}</span>
                                        </Button>
                                    )}
                                </ButtonToolbar>
                                {renderTimeSlotForm(alternateForm.period.exclusions.timeSlot, cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].timeSlot)}
                                <ButtonToolbar>
                                    {cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.length > 0 && form.period.exclusions.isValid() && (
                                        <Button
                                            bsStyle='primary'
                                            bsSize='large'
                                            onClick={() => form.period.exclusions.add(null, {timeSlot: {timeSlotType: TIME_SLOT_TYPES[0]}})}>
                                            {i18n.addExclusion}
                                        </Button>
                                    )}
                                    {cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.length > 0 && (
                                        <Button
                                            bsStyle='danger'
                                            bsSize='large'
                                            onClick={() => form.period.exclusions.remove()}>
                                            {i18n.removeExclusion}
                                        </Button>
                                    )}
                                </ButtonToolbar>
                            </div>
                        )}
                    </div>
                )}
                {form.period.days && (
                    <div className={style.section}>
                        <h5>{i18n.days} <i>*</i></h5>
                        <ul className={style.group}>
                            {cmd && cmd.period && cmd.period.days && cmd.period.days.slice(1).reverse().map((day, index) => (
                                <li key={index}>
                                    <a
                                        href=''
                                        className={style.remove}
                                        onClick={(e) => form.period.days.remove(e, day)}>
                                        <Icon icon='minus' size='xs' />
                                    </a>
                                    <p>{moment(day).format(i18n.dateFormat.longer)}</p>
                                </li>
                            ))}
                        </ul>
                        <div className={style.dayPicker}>
                            <DayPicker
                                {...arrayItemField(form.period.days())} />
                        </div>
                        <ButtonToolbar>
                            {form.period.days.isValid() && (
                                <Button
                                    bsStyle='link'
                                    onClick={() => form.period.days.add()}>
                                    <Icon icon='plus' size='xs' />
                                    <span>{i18n.add}</span>
                                </Button>
                            )}
                            {cmd && cmd.period && cmd.period.days && cmd.period.days.length > 1 && (
                                <Button
                                    bsStyle='link'
                                    onClick={() => form.period.days.remove()}>
                                    <Icon icon='minus' size='xs' />
                                    <span>{i18n.remove}</span>
                                </Button>
                            )}
                        </ButtonToolbar>
                    </div>
                )}
                {form.period.timeSlot && renderTimeSlotForm(form.period.timeSlot, cmd && cmd.period && cmd.period.timeSlot)}
                {form.period.startDate && form.period.endDate && (
                    <div className={style.section}>
                        <h5>
                            {cmd && cmd.period && cmd.period.periodType == 'WeekDaysPeriod' && (
                                <a
                                    href=''
                                    onClick={(e) => this._toggleSection(e, 'StartEndDate')}>
                                    <span>{i18n.period}</span>
                                    <Icon icon={openedSections.indexOf('StartEndDate') >= 0 && 'up' || 'down'} size='xs' />
                                </a>
                            )}
                            {cmd && cmd.period && cmd.period.periodType != 'WeekDaysPeriod' && (
                                <span>{i18n.period} <i>*</i></span>
                            )}
                        </h5>
                        {((cmd && cmd.period && cmd.period.periodType != 'WeekDaysPeriod') || openedSections.indexOf('StartEndDate') >= 0) && (
                        <div>
                            <DayRangePicker
                                {...periodField(form.period())} />
                            <ButtonToolbar>
                                {cmd && cmd.period && (cmd.period.startDate || cmd.period.endDate) && (
                                    <Button
                                        bsStyle='link'
                                        {...buttonField(periodField(form.period()), null)}>
                                        <Icon icon='minus' size='xs' />
                                        <span>{i18n.removeDayRange}</span>
                                    </Button>
                                )}
                            </ButtonToolbar>
                        </div>
                        )}
                    </div>
                )}
                {interventionPeriods && (
                    <div className={style.section}>
                        <h5>
                            <a
                                href=''
                                onClick={(e) => this._toggleSection(e, 'Copy')}>
                                <span>{i18n.fillinAssistant}</span>
                                <Icon icon={openedSections.indexOf('Copy') >= 0 && 'up' || 'down'} size='xs' />
                            </a>
                        </h5>
                        {openedSections.indexOf('Copy') >= 0 && (
                            <form>
                                <Input
                                    type='select'
                                    name='activity'
                                    {...activeInterventionPeriodField()}>
                                    <option value=''>{i18n.copyInterventionPeriod} ...</option>
                                    {interventionPeriods.map((interventionPeriod, index) => (
                                        <option
                                            key={index}
                                            value={interventionPeriod.uid}>
                                            {interventionPeriod.period.label}
                                        </option>
                                    ))}
                                </Input>
                            </form>
                        )}
                    </div>
                )}
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={(e) => form.validate() && this._sendCmd(e) || dispatch(errorStatus(i18n.formInvalid))}>
                        {interventionPeriod && i18n.validate || i18n.save}
                    </Button>
                </ButtonToolbar>
            </div>
        )
    }
}

DefineUpdateInterventionPeriodForActivityForm = connectForm({
    name: 'alternateForm',
    target: 'cmd',
    schema: DefineUpdateInterventionPeriodForActivityCmd.selectAlternateSchema,
    action: DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED
})(DefineUpdateInterventionPeriodForActivityForm)

DefineUpdateInterventionPeriodForActivityForm = connectForm({
    target: 'cmd',
    schema: DefineUpdateInterventionPeriodForActivityCmd.selectSchema,
    action: DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED
})(DefineUpdateInterventionPeriodForActivityForm)

DefineUpdateInterventionPeriodForActivityForm = connect((state) => ({
    cmd: state.provider.defineUpdateInterventionPeriodForActivityCmd
}))(DefineUpdateInterventionPeriodForActivityForm)

export default DefineUpdateInterventionPeriodForActivityForm


// WEBPACK FOOTER //
// ./lib/provider/components/DefineUpdateInterventionPeriodForActivityForm.js